







































































import Vue from 'vue';

interface IData {
  isAdded: boolean;
}

interface IMethods {
  goToShow: () => void;
  writeReview: () => void;
  interact: () => void;
  unlike: () => void;
  like: () => void;
}

interface IComputed {
  isSaved: boolean;
}

interface IProps {
  id: number;
  title: string;
  duration: string;
  genres: string[];
  released: string;
  imageUrl: string;
  padding: boolean;
  saved: boolean;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'ShowCardItem',

  props: {
    id: {
      type: Number,
      default: 0,
    },

    title: {
      type: String,
      required: true,
    },

    duration: {
      type: String,
      required: true,
    },

    genres: {
      type: Array,
      required: true,
    },

    released: {
      type: String,
      required: true,
    },

    imageUrl: {
      type: String,
      required: true,
    },

    padding: {
      type: Boolean,
      default: false,
    },

    saved: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isAdded: false,
  }),

  methods: {
    goToShow(): void {
      this.$router.push(`/show/${this.id}`);
    },

    writeReview(): void {
      this.$router.push(`/review/${this.id}`);
    },

    interact(): void {
      if (this.saved) {
        this.unlike();
      } else {
        this.like();
      }
      this.isAdded = !this.isAdded;
    },

    unlike(): void {
      this.$emit('unlike', this.id);
    },

    like(): void {
      console.log('If we had any features like that I\'d add it for you');
    },
  },

  computed: {
    isSaved(): boolean {
      return this.saved || this.isAdded;
    },
  },
});
